// @flow
export const SET_SCHEDULE_ID = 'schedule:addUUID';
export const ADD_TITLE = 'schedule:addTitle';
export const ADD_LEARNING_CONTENT = 'schedule:addContent';
export const DISCARD_LEARNING_CONTENT = 'schedule:discardContent';
export const REMOVE_LEARNING_CONTENT = 'schedule:removeContent';
export const SET_GOAL_DATE = 'schedule:goalDate';
export const SET_LONG_TERM = 'schedule:longTerm';
export const SET_STUDY_DURATION = 'scheudle:studyDuration';
export const SET_TIME_REMINDER = 'schedule:reminderTime';
export const DISCARD = 'schedule:discard';
export const SHOW = 'schedule:show';
export const SHOW_DISCARD_SCHEDULE = 'schedule:discardModal';
export const SHOW_DATE_PICKER = 'set:datePicker';
export const SHOW_EDIT_DATE = 'set:editDate';
export const SHOW_TIME_PICKER = 'set:timePicker';
export const SHOW_EDIT_TIME = 'set:editTime';
export const SET_EDIT_CONTENT = 'set:editContent';
export const SET_EDIT_MODE = 'set:editMode';
export const SHOW_SLIDER = 'schedule:showSlider';
export const SELECT_LEARNING_TYPE = 'schedule:learningType';
export const SET_SELECTED_SCHEDULE_ID = 'set:scheduleId';
export const SHOW_CONTENT_DIALOG = 'schedule:openDialog';
export const SET_MAX_STUDY_DURATION = 'set:maxDuration';
export const SET_SEARCH_QUERY = 'set:search';
export const SET_ADDED_CONTENTS = 'set:addedContents';
export const SET_ARCHIEVE = 'set:Arhieve';
